let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6NA23")).then(() => parcelRequire('fL2q9'));